import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class FlashController extends Controller {
  static values = { 
    delay: { type: Number, default: 5000 },
    animationDuration: { type: Number, default: 300 }
  }
  
  connect() {
    console.log('Flash controller connected', this.element, 'delay:', this.delayValue)
    
    // Auto-dismiss after delay
    if (this.delayValue > 0) {
      console.log('Setting timeout for', this.delayValue, 'ms')
      this.timeout = setTimeout(() => {
        console.log('Auto-dismissing flash message')
        this.remove()
      }, this.delayValue)
    }
  }
  
  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
  
  remove(event) {
    console.log('Remove called', event)
    
    // Prevent default if triggered by click
    if (event) {
      event.preventDefault()
    }
    
    // Clear timeout if dismissing manually
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    
    // Add fade out animation
    this.element.classList.add('opacity-0', 'translate-x-full')
    this.element.classList.add('transition-all', 'duration-300')
    
    // Remove element after animation completes
    setTimeout(() => {
      console.log('Removing element from DOM')
      this.element.remove()
    }, this.animationDurationValue)
  }
}